module.exports = __webpack_public_path__ + "static/media/baner-home-mysli.3171ce82.jpg";